import { createSlice } from '@reduxjs/toolkit';
import { FIELD_CLASS } from '../../utils/constants';
import { MANAGER } from '../types';

const managerSlice = createSlice({
    name: MANAGER,
    initialState: {
        selectedRow: false,
        isRemoveManager: false,
        data: {},
        formInfo: false,
        managerOptions: {
            name: {
                name: 'name',
                type: 'text',
                label: 'Staff Name',
                className: FIELD_CLASS,
                disabled: true
            },
            phoneNumber: {
                name: 'phoneNumber',
                type: 'number',
                label: 'Phone Number',
                className: FIELD_CLASS,
                disabled: true
            },
            email: {
                name: 'email',
                type: 'text',
                label: 'Email',
                className: FIELD_CLASS,
                disabled: true
            },
            onboarded: {
                name: 'onboarded',
                type: 'text',
                label: 'Onboarded',
                className: FIELD_CLASS,
                disabled: true
            },
            hotel: {
                name: 'hotel',
                type: 'select',
                label: 'Hotel Name',
                className: 'col my-2',
                isMulti: false,
                options: []
            },
            orderManager: {
                name: 'orderManager',
                type: 'checkbox',
                label: 'Grant Order Manager access to this staff member.',
                className: `col-12 my-2 gap-2 d-flex flex-row-reverse align-items-center justify-content-center`,
                removeOnFieldUpdate: 'hotel'
            },
            table: {
                name: 'table',
                type: 'select',
                label: 'Select Table ( Leave blank to assign all )',
                className: 'col-12 my-2',
                isMulti: false,
                options: [],
                removeOnFieldUpdate: 'hotel'
            }
        },
        sorting: [],
        filtering: {},
        pagination: {
            pageIndex: 0,
            pageSize: 10
        },
        listChange: false
    },
    reducers: {
        setSelectedRow(state, action) {
            state.selectedRow = action.payload;
        },
        getManagersRequest() { },
        getManagerSuccess(state, action) {
            state.data = action.payload;
            state.managerOptions.table.options = [{ label: 'Select...', value: -1 }].concat(
                [...new Array(action.payload.tableCount || 0)].map((_obj, index) => ({ label: `Table Number - ${index + 1}`, value: index + 1 })
                ));
        },
        setFormInfo(state, action) {
            state.formInfo = action.payload;
        },
        updateManagerRequest() { },
        changeManagerSuccess(state) {
            state.listChange = !state.listChange;
        },
        removeManagerRequest() { },
        setHotelOption(state, action) {
            state.managerOptions.hotel.options = action.payload;
        },
        setManagerSorting(state, action) {
            state.sorting = action.payload;
        },
        setManagerFiltering(state, action) {
            state.filtering = action.payload;
        },
        setManagerPagination(state, action) {
            state.pagination = action.payload;
        },
        resetStaffFilters(state) {
            state.sorting = [];
            state.filtering = {};
            state.pagination = { pageIndex: 0, pageSize: 10 };
        }
    }
});

export const {
    setSelectedRow,
    getManagersRequest,
    getManagerSuccess,
    setFormInfo,
    updateManagerRequest,
    removeManagerRequest,
    setHotelOption,
    setManagerSorting,
    setManagerFiltering,
    setManagerPagination,
    changeManagerSuccess,
    resetStaffFilters
} = managerSlice.actions;

export const managerReducer = managerSlice.reducer;
